module.exports = __webpack_public_path__ + "static/media/cards.fd3f5d2f.png";